import ProductAndSubProductViewOnlyContainer from "./ProductAndSubProductViewOnlyContainer";

export default ProductAndSubProductViewOnlyContainer;
